import React from 'react'
import {getPlaceHolderImage} from '../../utils/helpers'
import {AutoSizer, List} from 'react-virtualized'
import {
  StyledNoBuildingText as NoBuildingText,
  StyledPhoto as Photo,
  StyledImage,
  StyledAddress,
  StyledName
} from './StyledBuildingList'
import styled from 'styled-components'
import Notification from '../../components/Notification/Notification'
import {fetchBuildings} from '../../utils/buildings'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {useViewFetch} from '../../utils/fetch'

const BuildingList = ({
  onBuildingSelect,
  onCloseNotification,
  showNotification
}) => {
  const localeState = useLocaleState()

  const {data: buildings, loading: isLoading} = useViewFetch({
    api: fetchBuildings,
    parameters: {},
    initialState: [],
    onChangeOf: []
  })

  const onBuildingClick = blId => onBuildingSelect(blId)

  const rowRenderer = ({index, key, style}) => {
    let building = buildings[index]

    const {name, blId, cityName, cityStateId, url} = building

    let imageUrl = url || getPlaceHolderImage('building')
    return (
      <div key={key} style={style}>
        <BuildingItem onClick={() => onBuildingClick(blId)}>
          <Photo>
            <StyledImage src={imageUrl} height={60} width={60} />
          </Photo>
          <StyledName>
            {name} ({blId})
          </StyledName>
          <StyledAddress>
            {cityName}, {cityStateId}
          </StyledAddress>
        </BuildingItem>
      </div>
    )
  }

  const noRowsRenderer = () => (
    <NoBuildingText>
      <div>{_L({key: 'No Buildings Available', localeState})}</div>
    </NoBuildingText>
  )

  const ITEM_COUNT = buildings.length
  const ROW_HEIGHT = 97
  return isLoading ? null : (
    <StyledContainer>
      <StyledHeaderText>
        {_L({key: 'Select a Building', localeState})}
      </StyledHeaderText>
      <div style={{height: 'calc(100vh - 200px)'}}>
        <AutoSizer>
          {({width, height}) => {
            return (
              <StyledList
                height={height}
                overscanRowCount={10}
                rowCount={ITEM_COUNT}
                rowHeight={ROW_HEIGHT}
                rowRenderer={rowRenderer}
                width={width}
                noRowsRenderer={noRowsRenderer}
              />
            )
          }}
        </AutoSizer>
        <Notification
          show={showNotification}
          onClose={onCloseNotification}
          message1={_L({
            key: 'This building has no reservable rooms.',
            localeState
          })}
          message2={_L({
            key: 'Please select a different building.',
            localeState
          })}
        />
      </div>
    </StyledContainer>
  )
}

export default BuildingList

const StyledContainer = styled.div`
  height: calc(100vh - 80px);
  width: calc(100vw);
  padding: 24px 240px 24px 240px;
  font-size: 16px;
  box-sizing: border-box;
  background-color: #eff0f3;
  grid-row: 2;
  grid-column: 1 / 4;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 24px;
  }

  @media (max-width: 768px) {
    grid-row: 2 / 4;
    grid-column: 1;
  }
`

const StyledList = styled(List)`
  width: 100%;
  height: calc(100vh - 200px);
  overflow-y: scroll;
  background-color: #ffffff;
  border-radius: 6px;

  @media (max-width: 420px) {
    border-radius: 0;
  }
`

const StyledHeaderText = styled.div`
  height: 65px;
  font-weight: 600;
  color: #000000;
  font-size: 24px;
  padding-top: 10px;
  padding-bottom: 16px;
  box-sizing: border-box;
`

const BuildingItem = styled.div`
  width: 100%;
  padding: 18px 24px 18px 24px;
  align-items: center;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 60px auto 70px;
  grid-template-areas: 'photo name icon' 'photo address icon';
  box-sizing: border-box;
  grid-column-gap: 10px;
  grid-row-gap: 0;
  background-color: white;
  border-bottom: 1px solid #f3f5fb;
  cursor: pointer;

  &:hover {
    background-color: #f3f9ff;
  }

  @media (max-width: 420px) {
    padding: 18px 0 18px 16px;
    grid-template-columns: 60px auto 40px;
  }
`
